import Navbar from "./components/Navbar"
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import Homepage from './Pages/Homepage'
import Singlepage from "./Pages/Singlepage";
import About from "./Pages/Aboutpage";


function App() {
  return (

   <Router>
    <Navbar/>
    <div className="container">
      <Switch>
        <Route exact path = '/'  component = {Homepage } />
        <Route  path="/about"  component=  {About}  />
        <Route path="/singleshow/:id" component = {Singlepage} />
     


      </Switch>

    </div>
   </Router>
  
  )
}

export default App




